import { TechnicalAddCounterModel } from "../../../../models/TechnicalUsers";

export const actionTypes = {
  GET_ALL_COUNTERS: "GET_ALL_COUNTERS",
  GET_ALL_COUNTERS_SUCCESS: "GET_ALL_COUNTERS_SUCCESS",
  GET_ALL_COUNTERS_FAILURE: "GET_ALL_COUNTERS_FAILURE",

  GET_OU_COUNTERS: "GET_OU_COUNTERS",
  GET_OU_COUNTERS_SUCCESS: "GET_OU_COUNTERS_SUCCESS",
  GET_OU_COUNTERS_FAILURE: "GET_OU_COUNTERS_FAILURE",

  GET_APP_COUNTERS: "GET_APP_COUNTERS",
  GET_APP_COUNTERS_SUCCESS: "GET_APP_COUNTERS_SUCCESS",
  GET_APP_COUNTERS_FAILURE: "GET_APP_COUNTERS_FAILURE",

  ADD_TECHNICAL_COUNTER: "ADD_TECHNICAL_COUNTER",
  ADD_TECHNICAL_COUNTER_SUCCESS: "ADD_TECHNICAL_COUNTER_SUCCESS",
  ADD_TECHNICAL_COUNTER_FAILURE: "ADD_TECHNICAL_COUNTER_FAILURE",

  UPDATE_TECHNICAL_COUNTER: "UPDATE_TECHNICAL_COUNTER",
  UPDATE_TECHNICAL_COUNTER_SUCCESS: "UPDATE_TECHNICAL_COUNTER_SUCCESS",
  UPDATE_TECHNICAL_COUNTER_FAILURE: "UPDATE_TECHNICAL_COUNTER_FAILURE",

  DELETE_TECHNICAL_COUNTER: "DELETE_TECHNICAL_COUNTER",
  DELETE_TECHNICAL_COUNTER_SUCCESS: "DELETE_TECHNICAL_COUNTER_SUCCESS",
  DELETE_TECHNICAL_COUNTER_FAILURE: "DELETE_TECHNICAL_COUNTER_FAILURE",

  GET_RIORG_TECHNICAL_IDENTITY: "GET_RIORG_TECHNICAL_IDENTITY",
  GET_RIORG_TECHNICAL_IDENTITY_SUCCES: "GET_RIORG_TECHNICAL_IDENTITY_SUCCES",
  GET_RIORG_TECHNICAL_IDENTITY_FAILURE: "GET_RIORG_TECHNICAL_IDENTITY_FAILURE",

  GET_RIORG_OU: "GET_RIORG_OU",
  GET_RIORG_OU_SUCCES: "GET_RIORG_OU_SUCCES",
  GET_RIORG_OU_FAILURE: "GET_RIORG_OU_FAILURE",

  RIORG_OU: "RIORG_OU",
  RIORG_OU_SUCCES: "RIORG_OU_SUCCES",
  RIORG_OU_FAILURE: "RIORG_OU_FAILURE",
};

export const getAllCountersAction = () => {
  return {
    type: actionTypes.GET_ALL_COUNTERS,
  };
};
export const getAllCountersActionSuccess = (payload: any) => {
  return {
    type: actionTypes.GET_ALL_COUNTERS_SUCCESS,
    payload,
  };
};
export const getAllCountersActionFailure = (payload: any) => {
  return {
    type: actionTypes.GET_ALL_COUNTERS_FAILURE,
    payload,
  };
};

export const getOuCountersAction = () => {
  return {
    type: actionTypes.GET_OU_COUNTERS,
  };
};
export const getOuCountersActionSuccess = (payload: any) => {
  return {
    type: actionTypes.GET_OU_COUNTERS_SUCCESS,
    payload,
  };
};
export const getOuCountersActionFailure = (payload: any) => {
  return {
    type: actionTypes.GET_OU_COUNTERS_FAILURE,
    payload,
  };
};

export const getApplicationCountersAction = () => {
  return {
    type: actionTypes.GET_APP_COUNTERS,
  };
};
export const getApplicationCountersActionSuccess = (payload: any) => {
  return {
    type: actionTypes.GET_APP_COUNTERS_SUCCESS,
    payload,
  };
};
export const getApplicationCountersActionFailure = (payload: any) => {
  return {
    type: actionTypes.GET_APP_COUNTERS_FAILURE,
    payload,
  };
};

export const addTechnicalUsersCounterAction = (
  payload: TechnicalAddCounterModel
) => {
  return {
    type: actionTypes.ADD_TECHNICAL_COUNTER,
    payload,
  };
};
export const addTechnicalUsersCounterActionSuccess = (payload: any) => {
  return {
    type: actionTypes.ADD_TECHNICAL_COUNTER_SUCCESS,
    payload,
  };
};
export const addTechnicalUsersCounterActionFailure = (payload: any) => {
  return {
    type: actionTypes.ADD_TECHNICAL_COUNTER_FAILURE,
    payload,
  };
};

export const updateTechnicalUsersCounterAction = (payload: any) => {
  return {
    type: actionTypes.UPDATE_TECHNICAL_COUNTER,
    payload,
  };
};
export const updateTechnicalUsersCounterActionSuccess = (payload: any) => {
  return {
    type: actionTypes.UPDATE_TECHNICAL_COUNTER_SUCCESS,
    payload,
  };
};
export const updateTechnicalUsersCounterActionFailure = (payload: any) => {
  return {
    type: actionTypes.UPDATE_TECHNICAL_COUNTER_FAILURE,
    payload,
  };
};

export const deleteTechnicalUsersCounterAction = (payload: string) => {
  return {
    type: actionTypes.DELETE_TECHNICAL_COUNTER,
    payload,
  };
};
export const deleteTechnicalUsersCounterActionSuccess = (payload: any) => {
  return {
    type: actionTypes.DELETE_TECHNICAL_COUNTER_SUCCESS,
    payload,
  };
};
export const deleteTechnicalUsersCounterActionFailure = (payload: any) => {
  return {
    type: actionTypes.DELETE_TECHNICAL_COUNTER_FAILURE,
    payload,
  };
};

export const getTechnicalUsersRiorgIdentityAction = () => {
  return {
    type: actionTypes.GET_RIORG_TECHNICAL_IDENTITY,
  };
};
export const getTechnicalUsersRiorgIdentityActionSuccess = (payload: any) => {
  return {
    type: actionTypes.GET_RIORG_TECHNICAL_IDENTITY_SUCCES,
    payload,
  };
};
export const getTechnicalUsersRiorgIdentityActionFailure = (payload: any) => {
  return {
    type: actionTypes.GET_RIORG_TECHNICAL_IDENTITY_FAILURE,
    payload,
  };
};

export const getTechnicalUsersRiorgOusAction = () => {
  return {
    type: actionTypes.GET_RIORG_OU,
  };
};
export const getTechnicalUsersRiorgOusActionSuccess = (payload: any) => {
  return {
    type: actionTypes.GET_RIORG_OU_SUCCES,
    payload,
  };
};
export const getTechnicalUsersRiorgOusActionFailure = (payload: any) => {
  return {
    type: actionTypes.GET_RIORG_OU_FAILURE,
    payload,
  };
};

export const riorgTechnicalUsersOusAction = (payload: string) => {
  return {
    type: actionTypes.RIORG_OU,
    payload,
  };
};
export const riorgTechnicalUsersOusActionSuccess = (payload: any) => {
  return {
    type: actionTypes.RIORG_OU_SUCCES,
    payload,
  };
};
export const riorgTechnicalUsersOusActionFailure = (payload: any) => {
  return {
    type: actionTypes.RIORG_OU_FAILURE,
    payload,
  };
};
